import { customNodeItemRender } from '../items/custom-node';
import { fitViewportItemRender } from '../items/fit-viewport';
import { hierarchyItemRender } from '../items/hierarchy';
import { referenceLinesItemRender } from '../items/reference-lines';
import { scaleItemRender } from '../items/scale';
import type { IStageToolbarItem } from '../types';

const BUILTIN_STAGE_TOOLBAR_ITEMS: IStageToolbarItem[] = [
    { key: 'reference-lines', sort: 10, render: referenceLinesItemRender },
    { key: 'hierarchy', sort: 20, render: hierarchyItemRender },
    { key: 'scale', sort: 30, render: scaleItemRender },
    { key: 'fit-viewport', sort: 40, render: fitViewportItemRender },
    { key: 'custom-node', sort: 50, render: customNodeItemRender },
];

export const getBuiltinStageToolbarItems = () => [...BUILTIN_STAGE_TOOLBAR_ITEMS];
